import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { AppSidebar, useCurrentNavItem } from '@/components/app-sidebar';
import { PageTitleInHeaderContext } from '@/components/page-header';
import { Separator } from '@/components/ui/separator';
import {
  SidebarInset,
  SidebarProvider,
  SidebarTrigger,
} from '@/components/ui/sidebar';

/** 顶部标题栏：折叠侧栏的按钮 + 当前页面名，和 shadcn dashboard 示例同一结构 */
function SiteHeader() {
  const current = useCurrentNavItem();
  return (
    <header className="flex h-12 shrink-0 items-center gap-2 border-b">
      <div className="flex w-full items-center gap-1 px-4 lg:gap-2 lg:px-6">
        <SidebarTrigger className="-ml-1" />
        <Separator
          orientation="vertical"
          className="mx-2 data-[orientation=vertical]:h-4"
        />
        <h1 className="text-base font-medium">
          {current?.label ?? '管理后台'}
        </h1>
      </div>
    </header>
  );
}

/**
 * 管理后台外壳：左侧浅灰侧栏，右侧一块浮起来的圆角面板（inset 布局）。
 * 页面名显示在面板顶部的标题栏里，页面内的 PageHeader 就不再重复一遍大标题。
 */
const AdminLayout: React.FC = () => (
  <SidebarProvider>
    <AppSidebar variant="inset" />
    {/* min-w-0：不然宽表格会把整块面板撑出屏幕，而不是在表格内部横向滚动 */}
    <SidebarInset className="min-w-0">
      <SiteHeader />
      <PageTitleInHeaderContext.Provider value={true}>
        {/*
         * 块级而不是 flex 纵向：flex 子元素加了 mx-auto 就按内容定宽，
         * 宽表格会撑出屏幕，窄页面又会缩在中间
         */}
        <div className="min-w-0 flex-1 p-4 lg:p-6">
          {/* 放在这一层，切页面时侧栏不跟着消失 */}
          <Suspense fallback={null}>
            <Outlet />
          </Suspense>
        </div>
      </PageTitleInHeaderContext.Provider>
    </SidebarInset>
  </SidebarProvider>
);

export default AdminLayout;
